export const pixelSize = 6